import React, { Suspense } from 'react'
import {
	Route,
	Routes
} from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCoreRoutes } from '../shared/coreRoutes'
import { getAuthRoutes } from '../shared/authRoutes'
import { getCommonRoutes } from '../shared/commonRoutes'
import SmartRedirect from "components/SmartRedirect/SmartRedirect"
import { NEW_START_GUIDE_ENABLED } from "components/StartGuide/featureFlag"
import { DocumentType } from 'containers/DocumentTemplate/common/constants'
import RouteChunkFallback from '../shared/RouteChunkFallback'
import {
	LazyAddons,
	LazyAddCustomer,
	LazyAddExemption,
	LazyAddStore,
	LazyCheckout,
	LazyCountryProducts,
	LazyCreateExemption,
	LazyCustomers,
	LazyDocumentTemplate,
	LazyDocuments,
	LazyEDocuments,
	LazyEinvoiceSettings,
	LazyInvoiceCreateV2Page,
	LazyPdfImportReviewPage,
	LazyInvoiceReportsPage,
	LazyLookUp,
	LazyOrderRegistration,
	LazyStartGuidePage,
	LazyStores,
	LazySubscription,
} from '../shared/heavyRouteChunks'

const RoutesForEinvoice = ({
	isLogged,
	isLoggingIn
}) => {
	const state = useSelector((state) => state)
	const openProjectName = state.user.openProjectName

	// Use shared routes instead of duplicating
	const commonRoutes = getCommonRoutes()
	const notLoggedInRoutes = getAuthRoutes(isLoggingIn)

	const loggedInRoutes = (
			<>
				{getCoreRoutes()}
				{NEW_START_GUIDE_ENABLED && (
					<Route
						path='/start-guide'
						element={<LazyStartGuidePage />}
					/>
				)}
				<Route
						path='/lookUp'
						element={<LazyLookUp />}
				/>
				<Route
						path='/'
						element={<LazyDocuments />}
				/>
				<Route
						path='/settings'
						element={<LazyEinvoiceSettings />}
				/>
				<Route
						path='/settings/country-specifics/:countryCode/products'
						element={<LazyCountryProducts />}
				/>
				<Route
						path='/settings/vat-registration/order'
						element={<LazyOrderRegistration />}
				/>
				<Route
						path='/integrations'
						element={<LazyStores openProjectName={openProjectName} />}
				/>
				<Route
						path='/integrations/add'
						element={<LazyAddStore openProjectName={openProjectName} />}
				/>

				<Route
						path='/subscription'
						element={<LazySubscription />}
				/>
				<Route
						path='/subscription/checkout'
						element={<LazyCheckout />}
				/>
				<Route
						path='/addons'
						element={<LazyAddons />}
				/>

				<Route
						path='/e-documents'
						element={<LazyEDocuments />}
				/>
				<Route
						path='/documents'
						element={<LazyDocuments />}
				/>
				<Route
						path='/documents/:type/create'
						element={<LazyDocumentTemplate />}
				/>
				<Route
						path='/documents/exemption/add'
						element={<LazyAddExemption />}
				/>
				<Route
						path='/documents/exemption/create'
						element={<LazyCreateExemption />}
				/>

				<Route
						path='/e-documents'
						element={<LazyDocuments />}
				/>
				<Route
						path='/customers'
						element={<LazyCustomers />}
				/>
				<Route
						path='/customers/create'
						element={<LazyAddCustomer />}
				/>

				<Route
						path='/reports'
						element={<LazyInvoiceReportsPage />}
				/>

				{/* Payment success routes */}
				<Route
						path='/payments/subscription_bin_success/'
						element={<SmartRedirect />}
				/>
				<Route
						path='/api/payments/subscription_bin_success/'
						element={<SmartRedirect />}
				/>

				{/* Create Invoices version 2 */}
				<Route
						path='/documents/v2/vat_invoice/create'
						element={<LazyInvoiceCreateV2Page type={DocumentType.InvoiceVAT} />}
				/>

				<Route
          path='/documents/v2/vat_invoice/edit'
          element={<LazyInvoiceCreateV2Page type={DocumentType.InvoiceVAT} />}
				/>

				<Route
          path='/documents/v2/sales_tax_invoice/create'
          element={<LazyInvoiceCreateV2Page type={DocumentType.InvoiceSalesTax} />}
				/>

        <Route
          path='/documents/v2/sales_tax_invoice/edit'
          element={<LazyInvoiceCreateV2Page type={DocumentType.InvoiceSalesTax} />}
        />

				<Route
						path='/documents/v2/exemption/create'
						element={<LazyCreateExemption />}
				/>

				<Route
						path='/documents/import/pdf/:draftId/review'
						element={<LazyPdfImportReviewPage />}
				/>

				<Route
						path='*'
						element={<SmartRedirect />}
				/>
			</>
	)

	return (
			<Suspense fallback={<RouteChunkFallback />}>
				<Routes >
					{commonRoutes}
					{isLogged ? loggedInRoutes : notLoggedInRoutes}
				</Routes >
			</Suspense>
	)
}

export default RoutesForEinvoice
